import { ScoreMark } from './types'

export const getScoreMark = (score: number): ScoreMark => {
  if (score === 5) return 'excellent'
  if (score === 4) return 'good'
  if (score === 3) return 'weak'
  return 'needs_work'
}
